import api from './api';

const advancePaymentService = {
  // Get all advance payments
  getAllAdvancePayments: async (params = {}) => {
    try {
      const response = await api.get('/advance-payment', { params });
      return response.data;
    } catch (error) {
      console.error('Error getting advance payments:', error);
      throw error;
    }
  },

  // Get a single advance payment by ID
  getAdvancePaymentById: async (id) => {
    try {
      const response = await api.get(`/advance-payment/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting advance payment:', error);
      throw error;
    }
  },

  // Get next advance number
  getNextAdvanceNumber: async () => {
    try {
      const response = await api.get('/advance-payment/code/next');
      return response.data;
    } catch (error) {
      console.error('Error getting next advance number:', error);
      throw error;
    }
  },

  // Get approved claims for settlement
  getApprovedClaimsForSettlement: async (params = {}) => {
    try {
      const response = await api.get('/advance-payment/approved-claims', { params });
      return response.data;
    } catch (error) {
      console.error('Error getting approved claims:', error);
      throw error;
    }
  },

  // Create a new advance payment
  createAdvancePayment: async (data) => {
    try {
      const response = await api.post('/advance-payment', data);
      return response.data;
    } catch (error) {
      console.error('Error creating advance payment:', error);
      throw error;
    }
  },

  // Update an advance payment
  updateAdvancePayment: async (id, data) => {
    try {
      const response = await api.put(`/advance-payment/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating advance payment:', error);
      throw error;
    }
  },

  // Approve an advance payment
  approveAdvancePayment: async (id, data = {}) => {
    try {
      const response = await api.put(`/advance-payment/${id}/approve`, data);
      return response.data;
    } catch (error) {
      console.error('Error approving advance payment:', error);
      throw error;
    }
  },

  // Mark advance payment as paid
  markAsPaid: async (id, data) => {
    try {
      const response = await api.put(`/advance-payment/${id}/mark-paid`, data);
      return response.data;
    } catch (error) {
      console.error('Error marking advance payment as paid:', error);
      throw error;
    }
  },

  // Settle advance payment against claims
  settleAdvancePayment: async (id, data) => {
    try {
      const response = await api.put(`/advance-payment/${id}/settle`, data);
      return response.data;
    } catch (error) {
      console.error('Error settling advance payment:', error);
      throw error;
    }
  },

  // Delete an advance payment
  deleteAdvancePayment: async (id) => {
    try {
      const response = await api.delete(`/advance-payment/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting advance payment:', error);
      throw error;
    }
  },

  // Get advance payment statistics
  getAdvancePaymentStats: async () => {
    try {
      const response = await api.get('/advance-payment/stats');
      return response.data;
    } catch (error) {
      console.error('Error getting advance payment stats:', error);
      throw error;
    }
  }
};

export default advancePaymentService;
